import { createSelector } from 'reselect';
import { AppStoreState } from 'types';

const checkForTrialLicense = () =>
  createSelector(
    (state: AppStoreState) => state.user.licenses,
    ({ app }: AppStoreState) => app.currentWorkbook,
    (userLicenses: any, currentWorkbook: any) => {
      if (!currentWorkbook?.products) return false;
      return (
        userLicenses
          .filter(({ productCurriculumId }) =>
            currentWorkbook.products.find(
              product => product.productCurriculumId === productCurriculumId
            )
          )
          .filter(({ licenseTypeId }) => licenseTypeId !== 6).length === 0
      );
    }
  );

const checkForExpiredLicense = () =>
  createSelector(
    (state: AppStoreState) => state.user.licenses,
    ({ app }: AppStoreState) => app.currentWorkbook,
    (userLicenses: any, currentWorkbook: any) => {
      if (!currentWorkbook) return false;
      if (!currentWorkbook?.products) return true;
      return (
        userLicenses
          .filter(({ productCurriculumId }) =>
            currentWorkbook.products.find(
              product => product.productCurriculumId === productCurriculumId
            )
          )
          .filter(license => license.licenseTypeId && !license.expired).length === 0
      );
    }
  );

export const hasClickAway = createSelector(
  (state: AppStoreState) => state.user.clickAways,
  clickAways => !!clickAways.length
);

export const getLicenseIsExpired: any = checkForExpiredLicense();
export const getLicenseIsTrial: any = checkForTrialLicense();
export const hasClickAwayOnly: any = createSelector(
  [hasClickAway, getLicenseIsExpired],
  (hasClickAway, isExpiredLicense) => {
    return hasClickAway && isExpiredLicense;
  }
);
